import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useQuery, UseQueryResult } from 'react-query';
import { ReactQueryKeys } from 'enums';

export const useFixedIncomeTranscations = (
  businessId: string,
): UseQueryResult<any> => {
  const { treasureApi } = useTreasureApi(ApiKeys.Custodian);

  return useQuery(
    [ReactQueryKeys.FixedIncomeTranscations, businessId],
    async () => {
      const response = await treasureApi().get(
        `/business/${businessId}/positions/fixed-income-transactions`,
      );

      return response.data;
    },
    {
      enabled: !!businessId,
    },
  );
};
